<template>
	<svg width="23px" height="23px" viewBox="0 0 23 23" version="1.1" xmlns="https://www.w3.org/2000/svg" xmlns:xlink="https://www.w3.org/1999/xlink">
	    <defs>
	        <polygon id="d-n-p1" points="0 0.0457041846 11.3315588 0.0457041846 11.3315588 5.77948718 0 5.77948718"></polygon>
	        <polygon id="d-n-p3" points="0.148741 0.183863905 5.889541 0.183863905 5.889541 6.12845547 0.148741 6.12845547"></polygon>
	    </defs>
	    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
	        <g transform="translate(-1186.000000, -8.000000)">
	            <g transform="translate(1186.000000, 8.000000)">
	                <circle fill="#b4b4b4" cx="11.5" cy="11.5" r="11.5"></circle>
	                <g transform="translate(6.192308, 5.307692)">
	                    <g transform="translate(0.000000, 6.192308)">
	                        <mask id="d-n-m2" fill="white">
	                            <use xlink:href="#d-n-p1"></use>
	                        </mask>
	                        <path d="M7.57435098,0.0457041846 C7.02528235,0.415129005 6.37023333,0.631513005 5.66580196,0.631513005 C4.96881176,0.631513005 4.32030196,0.418827877 3.77484118,0.0565696205 C1.98805686,0.923955056 0.498468627,2.92042111 -9.01960784e-05,5.15754501 L1.04122353,5.35196695 C4.09436078,5.92205557 7.23724314,5.92205557 10.2901549,5.35196695 L11.3316941,5.15754501 C10.7228706,2.99647916 9.39225294,0.927885108 7.57435098,0.0457041846" fill="#ffffff" mask="url(#d-n-m2)"></path>
	                    </g>
	                    <g transform="translate(2.760000, 0.000000)">
	                        <mask id="d-n-m4" fill="white">
	                            <use xlink:href="#d-n-p3"></use>
	                        </mask>
	                        <path d="M3.019141,0.183840089 C1.433751,0.183840089 0.148741,1.51470991 0.148741,3.15614778 C0.148741,4.41342441 0.903601,5.48588447 1.968731,5.92029867 C2.294411,6.05319512 2.647921,6.12845547 3.019141,6.12845547 C3.397031,6.12845547 3.756751,6.05105163 4.087261,5.91363003 C5.142961,5.47469068 5.889541,4.4065176 5.889541,3.15614778 C5.889541,1.51470991 4.604531,0.183840089 3.019141,0.183840089" fill="#ffffff" mask="url(#d-n-m4)"></path>
	                    </g>
	                </g>
	            </g>
	        </g>
	    </g>
	</svg>

</template>
<script>
export default { name: 'navbar-profile-icon' }
</script>
